import { render } from "./social-media-icons.vue?vue&type=template&id=89ad92c2"
import script from "./social-media-icons.vue?vue&type=script&lang=js"
export * from "./social-media-icons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__